import { MultiselectItem } from '@cokitchen/cokitchen-components/dist/form/multiselect/types';
import { createContext, useContext } from 'react';
import { BrandType, BrandWorkingHoursType, CreateBrandFormType, PolygonType } from 'utils/types';

export type BrandContextType = {
  activeBrand: BrandType;
  setActiveBrand: (brand: BrandType) => void;
  createBrandForm: CreateBrandFormType;
  setCreateBrandForm: (k: CreateBrandFormType) => void;
  brandWorkingHours: BrandWorkingHoursType[];
  setBrandWorkingHours: (k: BrandWorkingHoursType[]) => void;
  companyOptions: MultiselectItem[];
  loadingCompanyOptions: boolean;
  availablePolygons: PolygonType[];
  loadingPolygons: boolean;
};

export const BrandContext = createContext({} as BrandContextType);

const useBrandContext = () => {
  const context = useContext(BrandContext);
  return context;
};

export default useBrandContext;
